import { render, staticRenderFns } from "./popViewReturn.vue?vue&type=template&id=9c96bf16"
import script from "./popViewReturn.vue?vue&type=script&lang=js"
export * from "./popViewReturn.vue?vue&type=script&lang=js"
import style0 from "./popViewReturn.vue?vue&type=style&index=0&id=9c96bf16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports